import React from 'react';
import {FormattedMessage} from "react-intl";

export default function LoadingSpinner() {
  return <p className="m-5 text-center loading-text"><FormattedMessage id="_.loadingSpinnerText">{msg => msg}</FormattedMessage></p>
}
